import { Box, Progress } from '@fpxfd/next';
import React from 'react';
import $i18n from 'panda-i18n';
import uploadSuccess from '@/assets/images/base/uploadSuccess.png';
import uploadFail from '@/assets/images/base/uploadFail.png';
import styles from './index.module.scss';
import { StatesProps } from './index.interface';

interface Props {
  states: StatesProps;
  content: React.ReactNode;
}

const Dragger2 = ({ states, content }: Props) => {
  return (
    <Box className={`${styles.innerUpload} ${styles[states.status]}`} justify="center" align="center">
      {states.status === 'init' && content}
      {states.status === 'progress' && (
        <>
          <div>
            <Progress percent={states.percent} hasBorder size="large" />
          </div>
          <div>{$i18n.get({ id: 'Uploading.four_px', dm: '正在上传中…' })}</div>
        </>
      )}
      {states.status === 'success' && (
        <>
          <div>
            <img src={uploadSuccess} alt="" className={`${styles.img}`} />
          </div>

          <div>{states.fileName}</div>
          <span className={styles.reUpload}>{$i18n.get({ id: 'ReUpload.four_px', dm: '重新上传' })}</span>
        </>
      )}
      {states.status === 'error' && (
        <>
          <div>
            <img src={uploadFail} alt="" className={`${styles.img}`} />
          </div>
          <div>{states.fileName}</div>
          <span className={styles.reUpload}>{$i18n.get({ id: 'ReUpload.four_px', dm: '重新上传' })}</span>
        </>
      )}
    </Box>
  );
};

export default Dragger2;
